import { Router, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout/layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { ROUTE_AUTH, ROUTE_INDEX } from '@core/config/route-paths.config';
import { authGuard } from '@core/guards/auth.guard';
import { guestGuard } from '@core/guards/guest.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: ROUTE_INDEX,
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./views/views.route').then((mod) => mod.VIEWS_ROUTES),
    canActivate: [authGuard],
  },
  {
    path: ROUTE_AUTH,
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./views/auth/auth.route').then((mod) => mod.AUTH_ROUTES),
    canActivate: [guestGuard],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./views/error-pages/error-pages.route').then(
        (mod) => mod.ERROR_PAGES_ROUTES,
      ),
  },
];
